import { useNavigate } from "react-router-dom";
import { Logo, DonkeyMark } from "@/components/Logo";
import { Rocket, Wand2, TrendingUp, ArrowRight } from "lucide-react";

const JOURNEYS = [
  { id: "start", icon: Rocket, title: "Start", tag: "No idea yet",
    body: "You want extra or alternative income but don't have a clear business idea. The Donkey will discover what you could credibly build." },
  { id: "transform", icon: Wand2, title: "Transform", tag: "Have expertise or a rough idea",
    body: "You have expertise, an audience, a hobby, a qualification or a rough idea — but no coherent offer yet. Turn it into a proposition." },
  { id: "grow", icon: TrendingUp, title: "Grow", tag: "Already trading",
    body: "You already run a business that's stalled or lacks a clear way to win customers. The Donkey will diagnose the constraint." },
];

export default function JourneySelect({ onSelect }) {
  const navigate = useNavigate();
  const choose = (id) => onSelect(id);
  return (
    <div className="min-h-screen bg-donkey-bg grain flex flex-col">
      <div className="p-6"><Logo /></div>
      <div className="flex-1 mx-auto max-w-5xl w-full px-5 sm:px-8 py-6">
        <div className="flex items-center gap-3 mb-2">
          <DonkeyMark size={30} />
          <p className="text-xs uppercase tracking-[0.2em] text-donkey-orange">Where are you starting from?</p>
        </div>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight text-white">
          Pick your route. I'll ask the right questions.
        </h1>
        <p className="mt-3 text-donkey-grey max-w-2xl">
          I won't drag an established business through "what are your hobbies?" — nor pretend you already have an idea if you don't.
        </p>

        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {JOURNEYS.map((j) => (
            <button key={j.id} onClick={() => choose(j.id)}
              className="text-left card-donkey rounded-2xl p-7 hover:-translate-y-1 hover:border-donkey-orange/40 transition-all group"
              data-testid={`journey-${j.id}`}>
              <div className="w-11 h-11 rounded-xl bg-donkey-orange/10 flex items-center justify-center mb-5">
                <j.icon className="w-5 h-5 text-donkey-orange" />
              </div>
              <p className="text-[11px] uppercase tracking-[0.15em] text-donkey-grey">{j.tag}</p>
              <h3 className="font-heading font-semibold text-xl text-white mt-1">{j.title}</h3>
              <p className="text-sm text-donkey-grey mt-3 leading-relaxed">{j.body}</p>
              <span className="mt-5 inline-flex items-center text-sm text-donkey-orange">
                Choose {j.title} <ArrowRight className="w-4 h-4 ml-1.5 group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
